import React from 'react';
import { icon } from '../components/Editor/icon';

export const FONT_SIZES = {
  12: 'size--12',
  14: 'size--14',
  16: 'size--16',
};
export const ALIGNMENTS = ['align--left', 'align--center', 'align--right'];
export const ALIGNMENTS_ICON = {
  'align--left': [
    <icon.SvgAlignLeft />,
    <icon.SvgAlignLeft className="editor-formatting-text__color" />,
  ],
  'align--center': [
    <icon.SvgAlignCenter />,
    <icon.SvgAlignCenter className="editor-formatting-text__color" />,
  ],
  'align--right': [
    <icon.SvgAlignRight />,
    <icon.SvgAlignRight className="editor-formatting-text__color" />,
  ],
};

export const FONT_SIZE_KEYS = Object.keys(FONT_SIZES).map(size => +size);

export const FONT_SIZES_REVERSE = Object.fromEntries(
  Object.entries(FONT_SIZES).map(([key, value]) => [value, key]),
);
